import * as React from "react";
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import "./../../resources/forest.jpg";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Chip from '@material-ui/core/Chip';
import AlarmIcon from '@material-ui/icons/Alarm';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import grey from '@material-ui/core/colors/grey';
import SchoolIcon from '@material-ui/icons/School';
import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import { ExerciseTask, TaskOption, Exercise, Execution,Classroom } from '../server/ExamServer'
import ExamTask from "./ExamTask";
import ExamExercise from "./ExamExercise";
import CircularProgress from '@material-ui/core/CircularProgress';

import ExamServer from '../server/ExamServer'


const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});



export interface AdminClassRoomItemProps {

    onEdited?:() => void
    // onTimeExceeded:() => void

    classroom?:Classroom
}

export interface AdminClassRoomItemState {
    edit:boolean
    textPwd:string
    textName:string
}


class AdminClassRoomItem extends React.Component<AdminClassRoomItemProps, AdminClassRoomItemState> {

    server: ExamServer;
    constructor(props: AdminClassRoomItemProps) {
        super(props);
        this.state = {
            edit:this.props.classroom ?false:true,
            textPwd:this.props.classroom ? this.props.classroom.password: "",
            textName:this.props.classroom ? this.props.classroom.name: ""
        };
        this.server = new ExamServer()
    }

    activationCodeTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        this.setState({ textPwd: event.target.value });
    }
    nameTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        this.setState({ textName: event.target.value });
    }
    activationCodeTextKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            this.savePwd()
        }
    }
    toggleEditMode = () => {
        this.setState({edit:!this.state.edit})
        if(this.state.edit){
            this.props.onEdited && this.props.onEdited()
        }
    }
    
    savePwd = () => {
        if(this.props.classroom){
            this.server.editClassroom(this.props.classroom.id,this.state.textName, this.state.textPwd).then(classroom => {
                this.setState({
                    edit:false
                })
            })
        }
        else{
            this.server.addClassroom(this.state.textName,this.state.textPwd).then(classroom => {
                this.setState({
                    edit:false
                })
                this.props.onEdited && this.props.onEdited()
            })
        }

    }


    render() {

        return (
            // <React.Fragment>
            //     <Paper style={{marginTop:theme.spacing(3), padding :theme.spacing(2)}}>
            //         <Typography variant="body1" color="textPrimary" component="h5" gutterBottom>
            //           {this.props.classroom.name}
            //         </Typography>

            //         <Typography variant="subtitle1" color="textSecondary" component="p" gutterBottom>
            //           Code: {this.props.classroom.password}
            //         </Typography>

            //     </Paper>
            // </React.Fragment>





<Card style={{marginTop:theme.spacing(3)}}>
      <CardActionArea>
        <CardHeader
            avatar={
            <Avatar>
                            <SchoolIcon />
            </Avatar>
            }
            title={this.state.textName}
            subheader={"Access Code"}
        />

      </CardActionArea>


      <CardContent>
          <Paper elevation={0}>
              {!this.state.edit?(
            <Typography variant="h5" color="textSecondary" align={"center"}   style={{ backgroundColor: grey[100], padding:theme.spacing(2)}}>
             {this.state.textPwd}
            </Typography>):(

           <React.Fragment>
                <TextField
                    label="Company Name"
                    fullWidth
                    margin="normal"
                    value={this.state.textName}
                    onChange={this.nameTextChanged}
                    variant="outlined"

                />
                    <TextField
                    label="Access Code"
                    fullWidth
                    margin="normal"
                    value={this.state.textPwd}
                    onChange={this.activationCodeTextChanged}
                    onKeyPress={this.activationCodeTextKeyPress}
                    variant="outlined"

                />
           </React.Fragment>     
        
            )}

          </Paper>



        </CardContent>
      <CardActions>
      {!this.state.edit?(
        <Button size="small" color="primary" onClick={this.toggleEditMode}>
          Edit
        </Button>
        ):(
            <React.Fragment>
                <Button size="small" color="secondary" onClick={this.savePwd}>
                Save
                </Button>
                <Button size="small" color="primary" onClick={this.toggleEditMode}>
                Cancel
                </Button>
            </React.Fragment>

        )}

      </CardActions>
    </Card>

        );
    }
}

export default AdminClassRoomItem;
